import React, { ChangeEvent, KeyboardEvent, useState } from "react";
import { RowItem } from "../models/Core/row-item";
import * as app from "../services/AppService";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipElm from 'react-bootstrap/Tooltip';

interface InputProps extends RowItem, InterfaceComponentsProps {
    onChange?: (value: string, key: string | undefined) => void;
    model: string | number;
    onBlur?: () => void;
    elmKey?: string | number;
    required?: boolean;
    onEnterClicked?: () => void;
    iconClicked?: () => void;
    maxlength?: number;
    containerClass?: string;
    symbol?: string;
    placeholder?: string;
    iconClass?: string;
    tableClass?: string;
    tooltip?: string;
    inputType?: string
    faIcon?: string
}

function Input(props: InputProps) {
    const hasIcon = props.icon || props.faIcon;
    function handler(event: ChangeEvent<HTMLInputElement>) {
        const { value } = event.target;
        props.onChange?.(value, props.elmKey?.toString());
    }

    function hanldeKeydown(evt: KeyboardEvent<HTMLInputElement>): void {
        if (
            evt.key === "Enter" &&
            props.onEnterClicked &&
            typeof props.onEnterClicked == "function"
        )
            props.onEnterClicked();
    }

    function iconClicked() {
        if (props.iconClicked && typeof props.iconClicked == "function")
            props.iconClicked();
    }

    function inputBlur() {
        if (props.onBlur && typeof props.onBlur == "function") props.onBlur();
    }

    let input = (
        <input
            type={props.inputType || "text"}
            title={props.tooltip}
            maxLength={props.maxlength}
            id={props.id ? props.id : "inpt" + props.label}
            key={props.elmKey}
            className={`form-control form-control-sm min-height-29  ${props.required && !props.model
                    ? " is-invalid  border-1"
                    : props.isTable
                    ? " border-1  placeholder-center " + props.tableClass
                    : `${props.class?.includes("border") ? "" : "border-0"} ${hasIcon ? "rounded-e-1" : "rounded"} shadow-none` + props.class} ${props.disabled ? "opacity-75 cursor-not-allowed" : ""} `}
            disabled={props.disabled}
            onChange={handler}
            value={props.model}
            onBlur={inputBlur}
            onKeyDown={hanldeKeydown}
            placeholder={app.translate(props.placeholder) + props.symbol}
            required={props.required && !props.model}
            autoComplete="off"
        />
    );

    const renderButtonIcon = () => {
        if (props.icon || props.faIcon) {
            const IconButton = (
                <button
                    className={`btn btn-sm ${props.iconClass?.includes("border") ? "" : "border-0"} p-0 px-2 ${props.iconClass || ''}`}
                    type="button"
                    disabled={!props.iconClicked}
                    onClick={iconClicked}
                >
                    {props.faIcon
                        ? <i className={props.faIcon} />         
                        : <i className={`iconssc-${props.icon}`} />  
                    }
                </button>
            );

            if (props.iconTooltip) {
                return (
                    <OverlayTrigger
                    
                        key={props.elmKey + 'bottom'}
                        placement='bottom'
                        overlay={
                            <TooltipElm style={{ position: "fixed" }} id={`tooltip-bottom`}>
                                {app.translate(props.iconTooltip)}
                            </TooltipElm>
                        }
                    >
                        {IconButton}
                    </OverlayTrigger>
                );
            }

            return IconButton;
        }
        return null;
    };
    return props.isTable ? (
        <div className="focus-group"> {input} </div>
    ) : <div className={` ${!props.label ? "margin-top-25" : " "}`}>
        {props.label && (
                <label className={` ms-1 ${props.labelClass}`}>
                    {app.translate(props.label)}
                </label>        
        )}
            <div className={`input-group border rounded focus-group ${props.containerClass}`} >
                {input}
                {renderButtonIcon()}
        </div>
    </div>;
}

Input.defaultProps = {
    labelClass: "fw-semibold text-primary-emphasis",
    type: "text",
    disabled: false,
    required: false,
    elmKey: "input",
    isTable: false,
    withLabel: true,
    symbol: "",
    onEnterClicked: undefined,
    iconClicked: undefined,
    maxlength: undefined,
    containerClass: "",
    placeholder: "",
    icon: "",
    iconClass: "",
    tableClass: "",
    class: "",
}

export default Input;
